import angular from 'angular'
import modal from 'angular-ui-bootstrap/src/modal'
import pagination from 'angular-ui-bootstrap/src/pagination'
import passwordPoliciesCtrl from './passwordPoliciesCtrl'

import page from './view/passwordPolicies.html'

export default angular
    .module('system.syssetting.passwordPolicies', [modal, pagination])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('system.syssetting.passwordPolicies', {
            url: '/passwordPolicies',
            template: page,
            controller: 'passwordPoliciesCtrl',
            title: '密码策略',
        })
    }])
    .controller('passwordPoliciesCtrl', passwordPoliciesCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/passwordPolicies/index.js